import { useState } from "react";
import { Link } from "react-router-dom";

const INTENTIONS = [
  { valeur: "relation_serieuse", icone: "💍", titre: "Une relation sérieuse", description: "Construire quelque chose de durable" },
  { valeur: "rencontre_decontractee", icone: "🍷", titre: "Une rencontre décontractée", description: "Sans pression, pour voir où ça mène" },
  { valeur: "nouvelles_rencontres", icone: "✨", titre: "De nouvelles rencontres", description: "Élargir mon cercle, rencontrer du monde" },
  { valeur: "indecis", icone: "🤔", titre: "Je ne sais pas encore", description: "Je préfère explorer avant de me décider" },
];

// Motif de la page d'accueil FodindinCa : noir profond + halos orange / vert / or.
const FOND = `radial-gradient(ellipse at 88% 4%, rgba(224,86,56,0.34) 0, transparent 46%),
  radial-gradient(ellipse at 8% 96%, rgba(10,92,54,0.38) 0, transparent 46%),
  radial-gradient(ellipse at 52% 42%, rgba(212,175,55,0.16) 0, transparent 40%), #12100E`;
const ENCRE = "#F5F3F0";
const BORDURE = "rgba(255,255,255,0.18)";
const ORANGE = "#E05638";
const OR = "#D4AF37";
const SOURDINE = "#B6AEA6";

const btnGroupe = (actif) => ({
  flex: 1, padding: 12, borderRadius: 10,
  border: `2px solid ${actif ? ORANGE : BORDURE}`,
  background: actif ? "rgba(224,86,56,0.18)" : "rgba(255,255,255,0.05)",
  color: actif ? "#fff" : ENCRE, fontWeight: actif ? 700 : 500,
  fontSize: 14, cursor: "pointer", fontFamily: "inherit",
});

export const LovePreferencesGate = ({ onComplete }) => {
  const [genre, setGenre] = useState(null);
  const [genreRecherche, setGenreRecherche] = useState(null);
  const [intention, setIntention] = useState(null);
  const [age, setAge] = useState("");
  const [conditions, setConditions] = useState(false);
  const [erreur, setErreur] = useState("");

  const complet = genre && genreRecherche && intention && parseInt(age, 10) >= 18 && conditions;

  const continuer = () => {
    const ageNum = parseInt(age, 10);
    if (ageNum < 18) {
      setErreur("Vous devez avoir 18 ans ou plus pour continuer.");
      return;
    }
    const prefs = { genre, genreRecherche, intention, age: ageNum, conditionsAccepteesLe: new Date().toISOString() };
    sessionStorage.setItem("fodindinLove_etape1", JSON.stringify(prefs));
    onComplete(prefs);
  };

  return (
    <div
      data-testid="love-preferences-gate"
      style={{ minHeight: "100vh", background: FOND, backgroundAttachment: "fixed", color: ENCRE,
        padding: 24, fontFamily: "'Segoe UI', Arial, sans-serif" }}
    >
      <div style={{ maxWidth: 480, margin: "0 auto", paddingTop: 70 }}>
        <div style={{ textAlign: "center", fontSize: 22, fontWeight: "bold", marginBottom: 4 }}>
          fodindin<span style={{ color: ORANGE }}>Love</span>
        </div>
        <div style={{ textAlign: "center", fontSize: 12, color: SOURDINE, marginBottom: 24 }}>Avant de consulter les annonces</div>

        <h1 style={{ fontSize: "1.4rem", textAlign: "center", margin: "0 0 6px" }}>Dites-nous ce que vous recherchez</h1>
        <p style={{ textAlign: "center", fontSize: 14, color: SOURDINE, marginBottom: 24 }}>
          Cela nous aide à vous proposer des profils qui vous correspondent vraiment.
        </p>

        <div style={{ marginBottom: 26 }}>
          <div style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5, color: OR, fontWeight: 700, marginBottom: 10 }}>Je suis</div>
          <div style={{ display: "flex", gap: 10 }}>
            {[["homme", "Un homme"], ["femme", "Une femme"], ["autre", "Autre"]].map(([v, l]) => (
              <button key={v} type="button" style={btnGroupe(genre === v)} onClick={() => setGenre(v)} data-testid={`gate-genre-${v}`}>{l}</button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 26 }}>
          <div style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5, color: OR, fontWeight: 700, marginBottom: 10 }}>Je recherche</div>
          <div style={{ display: "flex", gap: 10 }}>
            {[["homme", "Un homme"], ["femme", "Une femme"], ["peu_importe", "Peu importe"]].map(([v, l]) => (
              <button key={v} type="button" style={btnGroupe(genreRecherche === v)} onClick={() => setGenreRecherche(v)} data-testid={`gate-recherche-${v}`}>{l}</button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 26 }}>
          <div style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5, color: OR, fontWeight: 700, marginBottom: 10 }}>Votre âge</div>
          <input
            type="number"
            min={18}
            max={99}
            placeholder="Ex : 27"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            data-testid="gate-age"
            style={{ width: "100%", padding: 10, borderRadius: 8, border: `2px solid ${BORDURE}`, background: "rgba(255,255,255,0.05)", color: ENCRE, fontSize: 14 }}
          />
        </div>

        <div style={{ marginBottom: 26 }}>
          <div style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: 0.5, color: OR, fontWeight: 700, marginBottom: 10 }}>Je suis à la recherche de</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {INTENTIONS.map((c) => (
              <div
                key={c.valeur}
                onClick={() => setIntention(c.valeur)}
                data-testid={`gate-intention-${c.valeur}`}
                style={{
                  display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderRadius: 12,
                  border: `2px solid ${intention === c.valeur ? ORANGE : BORDURE}`,
                  background: intention === c.valeur ? "rgba(224,86,56,0.18)" : "rgba(255,255,255,0.05)",
                  cursor: "pointer", transition: "all 0.15s",
                }}
              >
                <span style={{ fontSize: 22 }}>{c.icone}</span>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: 14 }}>{c.titre}</div>
                  <div style={{ fontSize: 12, color: SOURDINE }}>{c.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <label style={{ display: "flex", gap: 10, alignItems: "flex-start", fontSize: 13, background: "rgba(255,255,255,0.05)", border: `1px solid ${BORDURE}`, padding: 14, borderRadius: 10, marginBottom: 20, cursor: "pointer" }}>
          <input type="checkbox" checked={conditions} onChange={(e) => setConditions(e.target.checked)} data-testid="gate-conditions" />
          <span>
            J'ai 18 ans ou plus et j'accepte les{" "}
            <Link to="/conditions-generales" target="_blank" style={{ color: OR, textDecoration: "underline" }}>Conditions Générales d'Utilisation</Link>{" "}
            et la <Link to="/confidentialite" target="_blank" style={{ color: OR, textDecoration: "underline" }}>politique de confidentialité</Link> de fodindinLove.
          </span>
        </label>

        <button
          type="button"
          disabled={!complet}
          onClick={continuer}
          data-testid="gate-continuer"
          style={{
            width: "100%", padding: 14, fontSize: 16, fontWeight: "bold", border: "none", borderRadius: 10,
            background: complet ? ORANGE : "rgba(255,255,255,0.18)", color: "#fff", cursor: complet ? "pointer" : "not-allowed", fontFamily: "inherit",
          }}
        >
          Continuer
        </button>
        {erreur && <p style={{ color: "#ff9b86", fontSize: 13, marginTop: 10, textAlign: "center" }} data-testid="gate-erreur">{erreur}</p>}
      </div>
    </div>
  );
};
